export const StockGroup = () => import("./StockGroup/List.vue");
export const StockGroupCreate = () => import("./StockGroup/Create.vue");
export const StockGroupEdit = () => import("./StockGroup/Edit.vue");

export const StockItem = () => import("./StockItem/List.vue");
export const Barcode = () => import("./StockItem/Barcode.vue");
export const StockItemCreate = () => import("./StockItem/Create.vue");
export const StockItemEdit = () => import("./StockItem/Edit.vue");
